module.exports = __webpack_public_path__ + "img/postgres.50156c71.png";